<template>
  <div class="swiper-container phone-swiper">
    <div class="swiper-wrapper">
      <div v-for="(item,index) in listImg" :key="index" class="swiper-slide">
        <img class="swiper-wrapper-img" :src="item.img" alt="">
      </div>
    </div>
    <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
    <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  props: [
    "listImg"
  ],
  data() {
    return {
      
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.init()
    })
  },
  methods: {
    init() {
      this.Swiper = new Swiper(".phone-swiper", {
        // direction: 'vertical', // 垂直切换选项
        loop: true, // 循环模式选项
        autoplay : {
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          delay: 6000,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        resistanceRatio:0
      });
    }
  },
}
</script>
<style lang="scss">
.phone-swiper{
  --swiper-navigation-color: #fff ;/* 单独设置按钮颜色 */
  --swiper-navigation-size: 20px;/* 设置按钮大小 */
  .swiper-button-next{
    right: 20px;
  }
  .swiper-button-prev{
    left: 20px;
  }
}
.swiper-wrapper-img{
  height: auto;
  width: 100%;
}
.swiper-slide{
  // box-sizing: content-box;
  // padding-bottom: 0.05rem;
  // margin-top: -0.05rem;
}
</style>